import * as React from "react";
import createNavigationContainerRef from "./createNavigationContainerRef";
export default function useNavigationContainerRef() {
    var navigation = React.useRef(null);
    if (navigation.current == null) {
        navigation.current = createNavigationContainerRef();
    }
    return navigation.current;
}
